import { Base } from '../base-component';
import './content-display-cards-with-icons-or-title.component.scss';

export class ContentDisplayCardsWithIconsOrTitle extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() { }

	bindEvents() { }

}



// WEBPACK FOOTER //
// ./components/content-display-cards-with-icons-or-title/content-display-cards-with-icons-or-title.component.ts